import * as Style from "style";

export const CardPadding = Style.Layout.Padding.Medium;
